import { useTranslation } from "react-i18next";
import "../assets/scss/components/language-switcher.scss";
import Dropdown from "./Dropdown";
import { ArrowDown } from "../assets/icons/Icons";

const LanguageSwitcher = () => {
  const { i18n, t } = useTranslation();

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng.value);
    localStorage.setItem("language", lng.value);
  };

  const languages = [
    { value: "en", label: "English", shortCode: "EN" },
    { value: "fr", label: "Français", shortCode: "FR" },
  ];
  return (
    <div className="language-switcher">
      <Dropdown
        dropdownTrigger={
          <div className="d-flex align-items-center user-dropdown">
            <svg
              width="20"
              height="20"
              viewBox="0 0 0.72 0.72"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="M.24.45H.105A.075.075 0 0 1 .03.375v-.27A.075.075 0 0 1 .105.03h.27A.075.075 0 0 1 .45.105V.24H.42V.105A.045.045 0 0 0 .375.06h-.27A.045.045 0 0 0 .06.105v.27A.045.045 0 0 0 .105.42H.24zM.239.306A.3.3 0 0 1 .126.36L.119.331A.3.3 0 0 0 .217.285.3.3 0 0 1 .147.15H.12V.12h.098L.202.104.223.083.261.12H.36v.03H.333a.3.3 0 0 1-.04.095.12.12 0 0 0-.055.061zM.24.265A.25.25 0 0 0 .302.15H.178A.25.25 0 0 0 .24.264m.45.349V.346A.076.076 0 0 0 .615.27H.347A.077.077 0 0 0 .27.347v.267A.077.077 0 0 0 .347.69h.267A.077.077 0 0 0 .69.613M.615.3A.046.046 0 0 1 .66.345v.269A.046.046 0 0 1 .615.66H.346A.046.046 0 0 1 .3.615V.346A.046.046 0 0 1 .345.3zM.552.54H.408L.373.607.346.593.48.336l.133.257-.027.014zM.536.51.48.402.424.51z" />
              <path fill="none" d="M0 0h.72v.72H0z" />
            </svg>
            <span className="text-uppercase">{i18n.language}</span>{" "}
            <ArrowDown className="hidden-sm" />
          </div>
        }
        dropdownMenu={
          <>
            {languages?.map((lang) => (
              <div
                className="dropdown-item cursor-pointer"
                key={lang.value}
                onClick={() => changeLanguage(lang)}
              >
                {lang.shortCode} - {lang.label}
              </div>
            ))}
          </>
        }
      />
    </div>
  );
};

export default LanguageSwitcher;
